import { ButtonProps } from '@mui/material/Button';
import './style.css';

interface IButtonProps extends ButtonProps {
  label: string;
  onClick: () => void;
  isReturnButton?: boolean;
  isHighlighted?: boolean;
  props?: ButtonProps;
}

export default function ButtonComponent({
  label,
  onClick,
  isReturnButton,
  isHighlighted,
  props,
}: IButtonProps) {
  const baseClass = isReturnButton ? 'button button-return' : 'button';
  const highlightClass = isHighlighted ? 'button-highlighted' : '';

  return (
    <div className="button-container">
      <button
        className={`${baseClass} ${highlightClass}`}
        onClick={() => onClick()}
        {...props}
      >
        {label}
      </button>
    </div>
  );
}
